import { ChangeDetectorRef, Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MenuModel } from '../../../models/layout/menu-item';

import { TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizationService } from '../../../Services/localization-service';
import { ChangeLanguageComponent } from '../../change-language-component/change-language-component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-menu-component',
  imports: [
    TranslatePipe,
    RouterModule,
    ChangeLanguageComponent
],
  templateUrl: './menu-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./menu-component.scss']
})
export class MenuComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly localizationService = inject(LocalizationService);

  menuModel = signal<MenuModel>({} as MenuModel);
  currentLang = environment.defaultLang;

 
  mobileMenuActive = signal(false);

  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
        if (lang != '') {
        this.currentLang = lang;
        this.cdr.detectChanges();
      }
    });

    const menuData = {
      "items": [
        { "id": 1, "name": "Home", "label": "", "order": 1, "group": "Main", "targetLink": '', "icon": "fa-solid fa-house" },
        { "id": 2, "name": "BLOGS", "label": "", "order": 2, "group": "Main", "targetLink": `blogs`, "icon": "fa-brands fa-blogger-b" },
        { "id": 3, "name": "Pricing", "label": "", "order": 3, "group": "Main", "targetLink": `pricing`, "icon": "fa-solid fa-tag" },
        { "id": 4, "name": "Services", "label": "", "order": 4, "group": "Main", "targetLink": `services`, "icon": "fa-solid fa-briefcase" },
        { "id": 5, "name": "Support", "label": "", "order": 5, "group": "Main", "targetLink": `support`, "icon": "fa-solid fa-headset" },
        { "id": 6, "name": "FAQ", "label": "", "order": 6, "group": "Main", "targetLink": `faq`, "icon": "fa-solid fa-circle-question" }
      ]
    } as MenuModel;

    this.menuModel.set(menuData);
  }

  toggleMobileMenu() {
    this.mobileMenuActive.update(active => !active);
  }

  closeMobileMenu() {
    this.mobileMenuActive.set(false);
  }
}